module.exports = __webpack_public_path__ + "0c52e07439f0ebe6fe40ccabb12d169d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/user3-128x128.jpg
// module id = ./assets/images/user3-128x128.jpg
// module chunks = 1